import React from 'react';
import RoleRibbon from './role-ribbon';
import { getRoleRibbonTabs } from './role-ribbon.config';

const RoleRibbonByRole = ({ role, navigate, translate, context = 'hacManagement' }) => {
  const tabs = getRoleRibbonTabs(role, context);

  return (
    <RoleRibbon
      tabs={tabs}
      navigate={navigate}
      translate={translate}
    />
  );
};

export default RoleRibbonByRole;
